import React from "react";
import { CheckCircle2 } from "lucide-react";
import { featurePoints } from "../mock";
import { SectionLabel, CountUp, OrangeButton } from "../components/common";

const Impact = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-5">
        <div className="mb-14 max-w-2xl">
          <SectionLabel>Our Impact</SectionLabel>
          <h2 className="section-heading text-[#0B102D] text-4xl md:text-5xl">
            Quality construction with modern equipment
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-7 items-stretch">
          {/* Big stat card */}
          <div className="relative rounded-lg overflow-hidden min-h-[340px]">
            <img
              src="https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
              alt="Skilled construction work"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#0B102D]/60" />
            <div className="absolute inset-0 flex flex-col justify-end p-8 text-white">
              <div className="display-heading text-6xl">
                <CountUp end={850} suffix="+" />
              </div>
              <p className="uppercase tracking-wide mt-2">Projects delivered</p>
            </div>
          </div>

          {/* Middle text card */}
          <div className="bg-[#F1F3F7] rounded-lg p-8 flex flex-col justify-center">
            <h3 className="font-display font-bold text-[#0B102D] text-2xl mb-4">
              From the drawing stage right through to completion
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our high quality staff and trusted sub-contractors take your project
              from concept to a finished build you will be proud of. No job is too
              small and the customer always comes first.
            </p>
            <ul className="space-y-3">
              {featurePoints.map((f) => (
                <li key={f} className="flex items-center gap-3 text-[#0B102D] font-medium">
                  <CheckCircle2 size={20} className="text-[#CD0008]" /> {f}
                </li>
              ))}
            </ul>
          </div>

          {/* CTA card */}
          <div className="bg-[#0B102D] rounded-lg p-8 flex flex-col justify-center text-white">
            <h3 className="font-display font-bold text-2xl mb-4">
              Contract managers who keep you informed
            </h3>
            <p className="text-white/70 leading-relaxed mb-8">
              Project based contract managers ensure the smooth running of the build,
              engaging at all times to make sure the project is exactly how you
              envisage it.
            </p>
            <OrangeButton to="/about">About Company</OrangeButton>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Impact;
